// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */
.Header-headerMenuOffcanvasBackShadow-FI6eH {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity .3s ease-in-out, visibility .3s ease-in-out;
    transition: opacity .3s ease-in-out, visibility .3s ease-in-out;
}
.Header-headerMenuOffcanvasBackShadow-FI6eH.Header-headerMenuBackShadowShow-JWQta {
    opacity: .5;
    visibility: visible;
}
.Header-frontPageHeader-gN054 {
    height: var(--frontPage-header-height);
    padding: 10px 24px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1032;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    background: var(--background-primary);
    gap: 12px;
}
.Header-headerLogoContainer-lI3_W {
    max-width: 11rem;
    height: 6rem;
    display: inline-block;
    /* Header band is tall enough (116px) to show the full 6rem logo — no clip. */
    overflow: visible;
}
/* Bigger logo: the container keeps the header height (72px) fixed, while the image is enlarged and
   overflows the container so the header row never grows. */
.Header-headerBrandLogo-pV08L {
    width: 8rem;
    height: 6rem;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: left;
       object-position: left;
    vertical-align: middle;
    margin-bottom: 0;
    display: inline-block;
}
/* Desktop: the estimator sits right next to the logo; margin-right:auto pushes
   the CTAs + login to the far right. (Mobile re-centers it — media query below.) */
.Header-estimatorSlot-Puviy { margin-right: auto; }
.Header-headerCtas-gWY5V { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 10px; }
.Header-headerBtnBook-LP7iv {
    background: #E8232B; color: #fff; font-weight: 700; font-size: 14.5px;
    padding: 10px 18px; border-radius: 999px; text-decoration: none; white-space: nowrap;
}
.Header-headerBtnBook-LP7iv:hover { background: #C2151C; }
.Header-headerBtnQuote-mXTW8 {
    background: #fff; color: #0A7C70; border: 1.5px solid #0A7C70; font-weight: 700;
    font-size: 14.5px; padding: 9px 18px; border-radius: 999px; text-decoration: none; white-space: nowrap;
}
.Header-headerBtnQuote-mXTW8:hover { background: #E4F6F3; }
.Header-headerHamburgBtn-RDXyE {
    display: none;
    outline: unset;
    border: unset;
    background: unset;
    padding: 0;
    width: 30px;
    height: 30px;
}
.Header-homeHeaderCloseBtn-PYRzc {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    border: unset;
    background: unset;
    padding: 0;
    width: 100%;
}
.Header-homeHeaderCloseBtn-PYRzc>svg {
    width: 24px;
    height: 24px;
    color: var(--primary-foreground);
}
.Header-headerHamburgBtn-RDXyE:hover,
.Header-headerHamburgBtn-RDXyE:focus,
.Header-homeHeaderCloseBtn-PYRzc:hover,
.Header-homeHeaderCloseBtn-PYRzc:focus {
    outline: unset;
    border: unset;
    background: unset;
}
.Header-headerHamburgBtn-RDXyE>svg {
    width: 100%;
    height: 100%;
    color: var(--primary-foreground);
}
.Header-headerMenuListWrapper-JmF5r {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 24px;
}
.Header-verticalHeaderMenuListWrapper-xXugH {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    /* Long menu (nav + account links) must scroll so the bottom items aren't cut off. */
    -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
            flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.Header-headerMenuList-oPMaq,
.Header-headerDropDownInnerList-xJ7tP {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 4px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    color: var(--primary-foreground);
    padding: 0;
    /* A crowded desktop header must squeeze via gaps — never by wrapping a
       menu item or the login pill into stacked letters. */
    white-space: nowrap;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}
.Header-headerMenuList-oPMaq svg,
.Header-headerDropDownInnerList-xJ7tP svg {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}
.Header-headerMenuList-oPMaq:hover,
.Header-headerMenuList-oPMaq:focus {
    color: var(--primary-foreground);
}
.Header-headerDropDownInnerListActive-OYkbx:hover,
.Header-headerDropDownInnerListActive-OYkbx:focus,
.Header-headerDropDownInnerListActive-OYkbx:active,
.Header-headerDropDownInnerListActive-OYkbx {
    color: var(--primary-link-foreground);
}
.Header-homeHeaderBtn-jI5K1 {
    padding: 8px 18px;
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    border-radius: 100px;
    white-space: nowrap;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}
/* Login/Signup button + a small caption below it clarifying this entry is for customers only. */
.Header-loginBtnWrap-fTzP9 {
    position: relative;
    display: inline-block;
}
.Header-loginHint-mysnm {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    margin-top: 4px;
    text-align: center;
    font-size: 10.5px;
    line-height: 1.2;
    font-weight: 600;
    color: #8a8f98;
    white-space: nowrap;
}
.Header-homeHeaderBtn-jI5K1,
.Header-homeHeaderBtn-jI5K1:focus,
.Header-homeHeaderBtn-jI5K1:hover {
    background-color: var(--primary-bg);
    color: var(--common-primary-white-foreground);
    border: unset;
    outline: unset;
    -webkit-box-shadow: unset;
            box-shadow: unset;
}
.Header-headerNavLogoContainer-SQP9Q {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.Header-headerNavLogoHamburg-ipmhC {
    position: relative;
    width: 20px;
    height: 20px;
}
.Header-headerNavLogoContainer-SQP9Q>img,
.Header-headerNavLogoHamburg-ipmhC>svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    -o-object-fit: cover;
       object-fit: cover;
}
.Header-activeListMenu-NmTBs {
    color: var(--primary-link-foreground) !important;
}
.Header-headerMenuItemIcon-ekSGg {
    width: 18px;
    height: 18px;
}
.Header-headerLogoTextContainer-lD99Q {
    max-width: 200px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}
.Header-headerLogoTextContainer-lD99Q,
.Header-headerLogoTextContainer-lD99Q:hover,
.Header-headerLogoTextContainer-lD99Q:focus {
    color: var(--primary-foreground);
    text-decoration: none;
}
.Header-headerLogoTextContainer-lD99Q>span {
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* header offcanvas */
.Header-mobileViewHeaderMenuOffCanvas-I_DN8 {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1050;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    max-width: var(--sideMenu-width);
    width: 100%;
    background-color: var(--background-primary);
    background-clip: padding-box;
    outline: 0;
    opacity: 0;
    padding: 20px 15px 50px;
    -webkit-transition: opacity 0.4s linear 0.3s,
        -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        transform 0.3s ease-in-out;
    transition: opacity 0.4s linear 0.3s,
        transform 0.3s ease-in-out,
        -webkit-transform 0.3s ease-in-out;
}
.Header-homeHeaderOffcanvasStart-qP5eL {
    right: 0;
    -webkit-transform: translateX(100%);
        -ms-transform: translateX(100%);
            transform: translateX(100%);
}
.Header-homeHeaderOffcanvasEnd-Y8cEo {
    left: 0;
    -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
            transform: translateX(-100%);
}
.Header-mobileViewHeaderMenuOffCanvas-I_DN8.Header-homeHeaderOffcanvasShow-Ed4on {
    -webkit-transform: none;
        -ms-transform: none;
            transform: none;
    opacity: 1;
    -webkit-transition: opacity 0.2s, -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.2s, -webkit-transform 0.3s ease-in-out;
    transition: opacity 0.2s, transform 0.3s ease-in-out;
    transition: opacity 0.2s, transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
}
.Header-headerBrandLogoWithTextContainer-cjkZ3 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 16px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    max-width: unset;
}
.Header-logoBrandNameText-nlQHy {
    font-size: 14px;
    display: inline-block;
    color: var(--primary-bg);
    font-weight: 500;
}
@media (min-width:1200px) {
    .Header-headerListWebHidden-vzyqg {
        display: none;
    }
}
@media (max-width:1199px) {
    .Header-headerListMobileHidden-ZYjoT {
        display: none;
    }

    /* Mobile header order: logo (left) · Estimate (centered, COMPACT pill) · hamburger
       (right). EstimatorDropdown auto-switches to its narrow "Estimate" pill at <=1199px,
       so it no longer overlaps the logo or bleeds over the login modal. */
    .Header-headerLogoContainer-lI3_W,
    .Header-headerLogoTextContainer-lD99Q {
        -webkit-box-ordinal-group: 2;
            -ms-flex-order: 1;
                order: 1;
    }
    .Header-estimatorSlot-Puviy {
        -webkit-box-ordinal-group: 3;
            -ms-flex-order: 2;
                order: 2;
        margin-left: auto;
        margin-right: auto;
        min-width: 0;
    }
    .Header-headerHamburgBtn-RDXyE {
        -webkit-box-ordinal-group: 4;
            -ms-flex-order: 3;
                order: 3;
    }
    /* Mobile: header wraps to a 2nd row so the two CTAs are always visible
       (full-width) right under the logo/Estimate row. */
    .Header-frontPageHeader-gN054 {
        height: auto;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        row-gap: 8px;
    }
    .Header-headerCtas-gWY5V {
        -webkit-box-ordinal-group: 5;
            -ms-flex-order: 4;
                order: 4;
        -ms-flex-preferred-size: 100%;
            flex-basis: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        gap: 10px;
    }
    .Header-headerCtas-gWY5V .Header-headerBtnBook-LP7iv,
    .Header-headerCtas-gWY5V .Header-headerBtnQuote-mXTW8 {
        -webkit-box-flex: 1;
            -ms-flex: 1 1;
                flex: 1 1;
        text-align: center;
    }

    /* In the collapsed hamburger menu, let the caption flow normally under the button (no overlap). */
    .Header-loginHint-mysnm {
        position: static;
        margin-top: 5px;
        text-align: left;
        white-space: normal;
    }

    .Header-headerHamburgBtn-RDXyE {
        display: block;
    }

    .Header-headerMenuList-oPMaq,
    .Header-headerMobileListContainer-OU2LV {
        width: 100%;
    }

    /* Scale the enlarged logo down on tablet/mobile so it never overlaps the menu/content. */
    .Header-headerLogoContainer-lI3_W {
        max-width: 8.5rem;
    }

    .Header-headerBrandLogo-pV08L {
        width: 7rem;
        height: 4.5rem;
        margin-bottom: -1rem;
    }
}
@media (max-width:475px) {
    .Header-headerLogoContainer-lI3_W {
        max-width: 7.5rem;
    }

    .Header-headerBrandLogo-pV08L {
        width: 6.25rem;
        height: 3.75rem;
        margin-bottom: -0.75rem;
    }

    .Header-headerBrandLogoWithTextContainer-cjkZ3 {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        height: auto;
        gap: 6px;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        -webkit-box-flex: 1;
            -ms-flex: 1 1;
                flex: 1 1;
        min-width: 0;
    }

    .Header-headerBrandLogoWithTextContainer-cjkZ3 img {
        width: 48px;
        height: 48px;
    }

    .Header-logoBrandNameText-nlQHy {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }

    .Header-frontPageHeader-gN054 {
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        padding: 12px 24px;
    }

}
/* Marketing nav links in the header (replaces dark/light toggle) */
.Header-navLink-Uw6La{font-weight:600;font-size:15px;color:#15191E;white-space:nowrap;padding:8px 10px;text-decoration:none;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}
/* Desktop ≤1680px: the nowrap header (nav + estimator + CTAs + login) is wider than the
   viewport — reclaim space via paddings/font so the Login pill never clips off-screen. */
@media (min-width: 992px) and (max-width: 1680px) {
  .Header-navLink-Uw6La{padding:8px 6px;font-size:14px}
  .Header-homeHeaderBtn-jI5K1{padding:8px 13px;font-size:14.5px}
  .Header-headerMenuList-oPMaq{font-size:14.5px}
}
.Header-navLink-Uw6La:hover{color:#E8232B}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,kBAAkB;IAClB,uEAAiE;IAAjE,+DAAiE;AACrE;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,qCAAqC;IACrC,SAAS;AACb;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,6EAA6E;IAC7E,iBAAiB;AACrB;AAEA;2DAC2D;AAC3D;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,wBAAqB;OAArB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;AACzB;AAEA;mFACmF;AACnF,8BAAiB,kBAAkB,EAAE;AACrC,2BAAc,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,SAAS,EAAE;AAC7D;IACI,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,iBAAiB;IACrE,kBAAkB,EAAE,oBAAoB,EAAE,qBAAqB,EAAE,mBAAmB;AACxF;AACA,oCAAuB,mBAAmB,EAAE;AAC5C;IACI,gBAAgB,EAAE,cAAc,EAAE,2BAA2B,EAAE,gBAAgB;IAC/E,iBAAiB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,qBAAqB,EAAE,mBAAmB;AAC1G;AACA,qCAAwB,mBAAmB,EAAE;AAE7C;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,WAAW;AACf;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AAEA;;;;IAII,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;AACb;AAEA;IACI,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,oFAAoF;IACpF,mBAAc;QAAd,kBAAc;YAAd,cAAc;IACd,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iCAAiC;AACrC;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,UAAU;IACV;0DACsD;IACtD,mBAAmB;IACnB,oBAAc;QAAd,cAAc;AAClB;AAEA;;IAEI,oBAAc;QAAd,cAAc;AAClB;AAEA;;IAEI,gCAAgC;AACpC;AAEA;;;;IAII,qCAAqC;AACzC;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAc;QAAd,cAAc;AAClB;AAEA,gGAAgG;AAChG;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AAEA;;;IAGI,mCAAmC;IACnC,6CAA6C;IAC7C,aAAa;IACb,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;AACrB;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,oBAAiB;OAAjB,iBAAiB;AACrB;AAEA;IACI,gDAAgD;AACpD;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AAEA;IACI,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;AAEA;;;IAGI,gCAAgC;IAChC,qBAAqB;AACzB;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,gCAAgC;IAChC,WAAW;IACX,2CAA2C;IAC3C,4BAA4B;IAC5B,UAAU;IACV,UAAU;IACV,uBAAuB;IACvB;0CAC8B;IAD9B;0CAC8B;IAD9B;kCAC8B;IAD9B;;0CAC8B;AAClC;AAEA;IACI,QAAQ;IACR,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;AAEA;IACI,OAAO;IACP,oCAA4B;QAA5B,gCAA4B;YAA5B,4BAA4B;AAChC;AAEA;IACI,uBAAe;QAAf,mBAAe;YAAf,eAAe;IACf,UAAU;IACV,oEAAoD;IAApD,4DAAoD;IAApD,oDAAoD;IAApD,wFAAoD;AACxD;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gBAAgB;AACpB;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;AACpB;AAEA;IACI;QACI,aAAa;IACjB;AACJ;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;;0EAEsE;IACtE;;QAEI,4BAAQ;YAAR,iBAAQ;gBAAR,QAAQ;IACZ;IACA;QACI,4BAAQ;YAAR,iBAAQ;gBAAR,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,4BAAQ;YAAR,iBAAQ;gBAAR,QAAQ;IACZ;IACA;wDACoD;IACpD;QACI,YAAY;QACZ,mBAAe;YAAf,eAAe;QACf,YAAY;IAChB;IACA;QACI,4BAAQ;YAAR,iBAAQ;gBAAR,QAAQ;QACR,6BAAgB;YAAhB,gBAAgB;QAChB,oBAAa;QAAb,oBAAa;QAAb,aAAa;QACb,SAAS;IACb;IACA;;QAEI,mBAAO;YAAP,aAAO;gBAAP,SAAO;QACP,kBAAkB;IACtB;;IAEA,kGAAkG;IAClG;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,WAAW;IACf;;IAEA,yFAAyF;IACzF;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,oBAAoB;IACxB;AACJ;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,YAAY;QACZ,QAAQ;QACR,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;QACvB,mBAAO;YAAP,aAAO;gBAAP,SAAO;QACP,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;QACvB,kBAAkB;IACtB;;AAEJ;AACA,mEAAmE;AACnE,sBAAS,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,0BAAmB,CAAnB,0BAAmB,CAAnB,mBAAmB,CAAC,wBAAiB,CAAjB,qBAAiB,CAAjB,kBAAkB;AACrJ;yFACyF;AACzF;EACE,sBAAS,eAAe,CAAC,cAAc;EACvC,4BAAe,gBAAgB,CAAC,gBAAgB;EAChD,6BAAgB,gBAAgB;AAClC;AACA,4BAAe,aAAa","sourcesContent":["/* new */\n.headerMenuOffcanvasBackShadow {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #000;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity .3s ease-in-out, visibility .3s ease-in-out, ;\n}\n\n.headerMenuOffcanvasBackShadow.headerMenuBackShadowShow {\n    opacity: .5;\n    visibility: visible;\n}\n\n.frontPageHeader {\n    height: var(--frontPage-header-height);\n    padding: 10px 24px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    z-index: 1032;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: var(--background-primary);\n    gap: 12px;\n}\n\n.headerLogoContainer {\n    max-width: 11rem;\n    height: 6rem;\n    display: inline-block;\n    /* Header band is tall enough (116px) to show the full 6rem logo — no clip. */\n    overflow: visible;\n}\n\n/* Bigger logo: the container keeps the header height (72px) fixed, while the image is enlarged and\n   overflows the container so the header row never grows. */\n.headerBrandLogo {\n    width: 8rem;\n    height: 6rem;\n    object-fit: contain;\n    object-position: left;\n    vertical-align: middle;\n    margin-bottom: 0;\n    display: inline-block;\n}\n\n/* Desktop: the estimator sits right next to the logo; margin-right:auto pushes\n   the CTAs + login to the far right. (Mobile re-centers it — media query below.) */\n.estimatorSlot { margin-right: auto; }\n.headerCtas { display: flex; align-items: center; gap: 10px; }\n.headerBtnBook {\n    background: #E8232B; color: #fff; font-weight: 700; font-size: 14.5px;\n    padding: 10px 18px; border-radius: 999px; text-decoration: none; white-space: nowrap;\n}\n.headerBtnBook:hover { background: #C2151C; }\n.headerBtnQuote {\n    background: #fff; color: #0A7C70; border: 1.5px solid #0A7C70; font-weight: 700;\n    font-size: 14.5px; padding: 9px 18px; border-radius: 999px; text-decoration: none; white-space: nowrap;\n}\n.headerBtnQuote:hover { background: #E4F6F3; }\n\n.headerHamburgBtn {\n    display: none;\n    outline: unset;\n    border: unset;\n    background: unset;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n}\n\n.homeHeaderCloseBtn {\n    display: flex;\n    justify-content: flex-end;\n    border: unset;\n    background: unset;\n    padding: 0;\n    width: 100%;\n}\n\n.homeHeaderCloseBtn>svg {\n    width: 24px;\n    height: 24px;\n    color: var(--primary-foreground);\n}\n\n.headerHamburgBtn:hover,\n.headerHamburgBtn:focus,\n.homeHeaderCloseBtn:hover,\n.homeHeaderCloseBtn:focus {\n    outline: unset;\n    border: unset;\n    background: unset;\n}\n\n.headerHamburgBtn>svg {\n    width: 100%;\n    height: 100%;\n    color: var(--primary-foreground);\n}\n\n.headerMenuListWrapper {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.verticalHeaderMenuListWrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    /* Long menu (nav + account links) must scroll so the bottom items aren't cut off. */\n    flex: 1 1 auto;\n    min-height: 0;\n    width: 100%;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n.headerMenuList,\n.headerDropDownInnerList {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    color: var(--primary-foreground);\n    padding: 0;\n    /* A crowded desktop header must squeeze via gaps — never by wrapping a\n       menu item or the login pill into stacked letters. */\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.headerMenuList svg,\n.headerDropDownInnerList svg {\n    flex-shrink: 0;\n}\n\n.headerMenuList:hover,\n.headerMenuList:focus {\n    color: var(--primary-foreground);\n}\n\n.headerDropDownInnerListActive:hover,\n.headerDropDownInnerListActive:focus,\n.headerDropDownInnerListActive:active,\n.headerDropDownInnerListActive {\n    color: var(--primary-link-foreground);\n}\n\n.homeHeaderBtn {\n    padding: 8px 18px;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n    border-radius: 100px;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n/* Login/Signup button + a small caption below it clarifying this entry is for customers only. */\n.loginBtnWrap {\n    position: relative;\n    display: inline-block;\n}\n.loginHint {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 100%;\n    margin-top: 4px;\n    text-align: center;\n    font-size: 10.5px;\n    line-height: 1.2;\n    font-weight: 600;\n    color: #8a8f98;\n    white-space: nowrap;\n}\n\n.homeHeaderBtn,\n.homeHeaderBtn:focus,\n.homeHeaderBtn:hover {\n    background-color: var(--primary-bg);\n    color: var(--common-primary-white-foreground);\n    border: unset;\n    outline: unset;\n    box-shadow: unset;\n}\n\n.headerNavLogoContainer {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.headerNavLogoHamburg {\n    position: relative;\n    width: 20px;\n    height: 20px;\n}\n\n.headerNavLogoContainer>img,\n.headerNavLogoHamburg>svg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: inherit;\n    object-fit: cover;\n}\n\n.activeListMenu {\n    color: var(--primary-link-foreground) !important;\n}\n\n.headerMenuItemIcon {\n    width: 18px;\n    height: 18px;\n}\n\n.headerLogoTextContainer {\n    max-width: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.headerLogoTextContainer,\n.headerLogoTextContainer:hover,\n.headerLogoTextContainer:focus {\n    color: var(--primary-foreground);\n    text-decoration: none;\n}\n\n.headerLogoTextContainer>span {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* header offcanvas */\n.mobileViewHeaderMenuOffCanvas {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: 1050;\n    display: flex;\n    flex-direction: column;\n    max-width: var(--sideMenu-width);\n    width: 100%;\n    background-color: var(--background-primary);\n    background-clip: padding-box;\n    outline: 0;\n    opacity: 0;\n    padding: 20px 15px 50px;\n    transition: opacity 0.4s linear 0.3s,\n        transform 0.3s ease-in-out;\n}\n\n.homeHeaderOffcanvasStart {\n    right: 0;\n    transform: translateX(100%);\n}\n\n.homeHeaderOffcanvasEnd {\n    left: 0;\n    transform: translateX(-100%);\n}\n\n.mobileViewHeaderMenuOffCanvas.homeHeaderOffcanvasShow {\n    transform: none;\n    opacity: 1;\n    transition: opacity 0.2s, transform 0.3s ease-in-out;\n}\n\n.headerBrandLogoWithTextContainer {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    max-width: unset;\n}\n\n.logoBrandNameText {\n    font-size: 14px;\n    display: inline-block;\n    color: var(--primary-bg);\n    font-weight: 500;\n}\n\n@media (min-width:1200px) {\n    .headerListWebHidden {\n        display: none;\n    }\n}\n\n@media (max-width:1199px) {\n    .headerListMobileHidden {\n        display: none;\n    }\n\n    /* Mobile header order: logo (left) · Estimate (centered, COMPACT pill) · hamburger\n       (right). EstimatorDropdown auto-switches to its narrow \"Estimate\" pill at <=1199px,\n       so it no longer overlaps the logo or bleeds over the login modal. */\n    .headerLogoContainer,\n    .headerLogoTextContainer {\n        order: 1;\n    }\n    .estimatorSlot {\n        order: 2;\n        margin-left: auto;\n        margin-right: auto;\n        min-width: 0;\n    }\n    .headerHamburgBtn {\n        order: 3;\n    }\n    /* Mobile: header wraps to a 2nd row so the two CTAs are always visible\n       (full-width) right under the logo/Estimate row. */\n    .frontPageHeader {\n        height: auto;\n        flex-wrap: wrap;\n        row-gap: 8px;\n    }\n    .headerCtas {\n        order: 4;\n        flex-basis: 100%;\n        display: flex;\n        gap: 10px;\n    }\n    .headerCtas .headerBtnBook,\n    .headerCtas .headerBtnQuote {\n        flex: 1;\n        text-align: center;\n    }\n\n    /* In the collapsed hamburger menu, let the caption flow normally under the button (no overlap). */\n    .loginHint {\n        position: static;\n        margin-top: 5px;\n        text-align: left;\n        white-space: normal;\n    }\n\n    .headerHamburgBtn {\n        display: block;\n    }\n\n    .headerMenuList,\n    .headerMobileListContainer {\n        width: 100%;\n    }\n\n    /* Scale the enlarged logo down on tablet/mobile so it never overlaps the menu/content. */\n    .headerLogoContainer {\n        max-width: 8.5rem;\n    }\n\n    .headerBrandLogo {\n        width: 7rem;\n        height: 4.5rem;\n        margin-bottom: -1rem;\n    }\n}\n\n@media (max-width:475px) {\n    .headerLogoContainer {\n        max-width: 7.5rem;\n    }\n\n    .headerBrandLogo {\n        width: 6.25rem;\n        height: 3.75rem;\n        margin-bottom: -0.75rem;\n    }\n\n    .headerBrandLogoWithTextContainer {\n        flex-direction: column;\n        height: auto;\n        gap: 6px;\n        align-items: flex-start;\n        flex: 1;\n        min-width: 0;\n    }\n\n    .headerBrandLogoWithTextContainer img {\n        width: 48px;\n        height: 48px;\n    }\n\n    .logoBrandNameText {\n        font-size: 14px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 100%;\n    }\n\n    .frontPageHeader {\n        align-items: flex-start;\n        padding: 12px 24px;\n    }\n\n}\n/* Marketing nav links in the header (replaces dark/light toggle) */\n.navLink{font-weight:600;font-size:15px;color:#15191E;white-space:nowrap;padding:8px 10px;text-decoration:none;display:inline-flex;align-items:center}\n/* Desktop ≤1680px: the nowrap header (nav + estimator + CTAs + login) is wider than the\n   viewport — reclaim space via paddings/font so the Login pill never clips off-screen. */\n@media (min-width: 992px) and (max-width: 1680px) {\n  .navLink{padding:8px 6px;font-size:14px}\n  .homeHeaderBtn{padding:8px 13px;font-size:14.5px}\n  .headerMenuList{font-size:14.5px}\n}\n.navLink:hover{color:#E8232B}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMenuOffcanvasBackShadow": `Header-headerMenuOffcanvasBackShadow-FI6eH`,
	"headerMenuBackShadowShow": `Header-headerMenuBackShadowShow-JWQta`,
	"frontPageHeader": `Header-frontPageHeader-gN054`,
	"headerLogoContainer": `Header-headerLogoContainer-lI3_W`,
	"headerBrandLogo": `Header-headerBrandLogo-pV08L`,
	"estimatorSlot": `Header-estimatorSlot-Puviy`,
	"headerCtas": `Header-headerCtas-gWY5V`,
	"headerBtnBook": `Header-headerBtnBook-LP7iv`,
	"headerBtnQuote": `Header-headerBtnQuote-mXTW8`,
	"headerHamburgBtn": `Header-headerHamburgBtn-RDXyE`,
	"homeHeaderCloseBtn": `Header-homeHeaderCloseBtn-PYRzc`,
	"headerMenuListWrapper": `Header-headerMenuListWrapper-JmF5r`,
	"verticalHeaderMenuListWrapper": `Header-verticalHeaderMenuListWrapper-xXugH`,
	"headerMenuList": `Header-headerMenuList-oPMaq`,
	"headerDropDownInnerList": `Header-headerDropDownInnerList-xJ7tP`,
	"headerDropDownInnerListActive": `Header-headerDropDownInnerListActive-OYkbx`,
	"homeHeaderBtn": `Header-homeHeaderBtn-jI5K1`,
	"loginBtnWrap": `Header-loginBtnWrap-fTzP9`,
	"loginHint": `Header-loginHint-mysnm`,
	"headerNavLogoContainer": `Header-headerNavLogoContainer-SQP9Q`,
	"headerNavLogoHamburg": `Header-headerNavLogoHamburg-ipmhC`,
	"activeListMenu": `Header-activeListMenu-NmTBs`,
	"headerMenuItemIcon": `Header-headerMenuItemIcon-ekSGg`,
	"headerLogoTextContainer": `Header-headerLogoTextContainer-lD99Q`,
	"mobileViewHeaderMenuOffCanvas": `Header-mobileViewHeaderMenuOffCanvas-I_DN8`,
	"homeHeaderOffcanvasStart": `Header-homeHeaderOffcanvasStart-qP5eL`,
	"homeHeaderOffcanvasEnd": `Header-homeHeaderOffcanvasEnd-Y8cEo`,
	"homeHeaderOffcanvasShow": `Header-homeHeaderOffcanvasShow-Ed4on`,
	"headerBrandLogoWithTextContainer": `Header-headerBrandLogoWithTextContainer-cjkZ3`,
	"logoBrandNameText": `Header-logoBrandNameText-nlQHy`,
	"headerListWebHidden": `Header-headerListWebHidden-vzyqg`,
	"headerListMobileHidden": `Header-headerListMobileHidden-ZYjoT`,
	"headerMobileListContainer": `Header-headerMobileListContainer-OU2LV`,
	"navLink": `Header-navLink-Uw6La`
};
module.exports = ___CSS_LOADER_EXPORT___;
